import React from 'react';

const TechsicoIncLogo = ({ color = 'black', opacity = '1', className }) => {
  return (
    <div className={`opacity-${parseFloat(opacity, 10) * 100} ${className}`}>
      <svg className={`fill-current text-${color}`}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 800 800"
        >
          {<path 
            className="a"
            d="m584 196.83c0-0.27687 1.05-1.3269 2.3333-2.3333 2.1148-1.6585 2.1619-1.6113 0.50342 0.50341-1.7418 2.221-2.8368 2.9273-2.8368 1.8299zm50.667-46.667c0-0.27686 1.05-1.3269 2.3333-2.3333 2.1148-1.6585 2.1619-1.6113 0.50341 0.50341-1.7418 2.221-2.8367 2.9273-2.8367 1.8299zm68-62.667c0-0.27687 1.05-1.3269 2.3333-2.3333 2.1148-1.6585 2.1619-1.6113 0.50341 0.50341-1.7418 2.221-2.8367 2.9273-2.8367 1.8299zm50.667-46.667c0-0.27688 1.05-1.3269 2.3333-2.3333 2.1147-1.6585 2.1619-1.6113 0.50341 0.50341-1.7418 2.221-2.8368 2.9273-2.8368 1.8299z" 
            transform="translate(307.95 13.389)"
          />}
          <path
            className="a"
            d="m-96.619 506.95v-278.33h-210.67v-241.33h450.67v558.01l-240 239.99zm306.67-390.92v-128.75h280.61l-3.303 3.146c-12.129 11.552-274.3 252.5-275.64 253.32-1.3289 0.81701-1.6667-25.067-1.6667-127.72z" 
            transform="translate(307.95 13.389)"
          /> 
      </svg>
    </div>
  );
};

export default TechsicoIncLogo;
